<mat-card class="example-card">
    <mat-card-header class="card-header">
      <mat-card-title class="card-titulo">Reporte de Consolidado de Caja</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      </div>

      <ng-container *ngIf="canView && !isValidating">

        <form [formGroup]="searchForm">

          <mat-expansion-panel>

            <mat-expansion-panel-header>
              <mat-panel-title class="card-subtitulo">
                <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Fecha Desde</mat-label>
                  <input matInput [matDatepicker]="fechaDesdePicker" formControlName="FechaDesde"  (click)="fechaDesdePicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaDesdePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaDesde')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaDesdePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Fecha Hasta</mat-label>
                  <input matInput [matDatepicker]="fechaHastaPicker" formControlName="FechaHasta"  (click)="fechaHastaPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaHastaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaHasta')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaHastaPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isMonedaSearching">{{'Moneda' | translate}}</mat-label>
                  <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                  <mat-select formControlName="MonedaId">
                    <mat-option>Todas</mat-option>
                    <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Vencimiento Desde</mat-label>
                  <input matInput [matDatepicker]="fechaVencimientoDesdePicker" formControlName="FechaVencimientoDesde"  (click)="fechaVencimientoDesdePicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoDesdePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoDesde')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimientoDesdePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Vencimiento Hasta</mat-label>
                  <input matInput [matDatepicker]="fechaVencimientoHastaPicker" formControlName="FechaVencimientoHasta"  (click)="fechaVencimientoHastaPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoHastaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaVencimientoHasta')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimientoHastaPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              </div>

              <!-- <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>{{'Proveedor' | translate}}</mat-label>
                  <input type="text" matInput [matAutocomplete]="proveedor" formControlName="Proveedor" style="width: 95%;">
                  <div *ngIf="isProveedorSearching" style="float: right;"><i class="fa fa-spinner fa-spin"></i></div>
                </mat-form-field>
                <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
                  <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                    {{s.RazonSocial}}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="!searchForm.controls['Proveedor'].valid && searchForm.controls['Proveedor'].touched">
                  {{ getErrorProveedor() }}
                </mat-error>
              </div> -->
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isConsorcioSearching">{{'Consorcio' | translate}}</mat-label>
                  <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                  <mat-select formControlName="ConsorcioId">
                    <mat-option>Todos</mat-option>
                    <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                  <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="ComunidadId" (selectionChange)="onDeudaFiltroUfComunidadSelect()">
                    <mat-option>Todos</mat-option>
                    <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{ 'UnidadFuncional' | translate}}</mat-label>
                  <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
                  <mat-select formControlName="UnidadFuncionalId">
                    <mat-option>Ninguna</mat-option>
                    <mat-option *ngFor="let s of ufList" [value]="s.Id">{{s.Codigo}}</mat-option>
                  </mat-select>
                </mat-form-field>

              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item" style="margin-top: 20px; text-align: center;">
                <mat-checkbox formControlName="DescartarPendientes" color="primary">No ver movimientos pendientes</mat-checkbox>
              </div>
              <div fxFlex=67 fxFlex.xs=100 class="flex-item" style="margin-top: 20px; text-align: center;">
                <mat-checkbox formControlName="VerBalancesNoCero" color="primary">Ver solo balances distinto de cero</mat-checkbox>
              </div>

            </div>

          </mat-expansion-panel>

          <br/>

          <mat-expansion-panel>

            <mat-expansion-panel-header>
              <mat-panel-title class="card-subtitulo">
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Configuraciones de Visualización
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Agrupar por</mat-label>
                  <mat-select formControlName="CampoAgrupador" (selectionChange)="onSearch()">
                    <mat-option *ngFor="let s of camposAgrupadoresList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isMonedaSearching">Visualizar unificado en</mat-label>
                  <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                  <mat-select formControlName="MonedaConversionId" (selectionChange)="onSearch()">
                    <mat-option>Ninguna</mat-option>
                    <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=25 fxFlex.xs=100 class="flex-item" style="margin-top: 15px; text-align: right;">
                <mat-checkbox [(ngModel)]="verSeparadoEnIva" [ngModelOptions]="{standalone: true}" color="primary" (change)="onChangeVerSeparadoEnIva()">Ver importe de IVA por separado</mat-checkbox>
              </div>
              <div fxFlex=25 fxFlex.xs=100 class="flex-item" style="margin-top: 15px; text-align: right;" *ngIf="!isRosbaco">
                <mat-checkbox formControlName="VerPorCuentaImputada" color="primary" (change)="onChangeVerCuentaImputada()">Ver desglosado por cuenta</mat-checkbox>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item">
                <button mat-raised-button (click)="pageGrid()" [disabled]="isProcessing()" class="zb-button">
                  {{gridAllowPaging ? 'Ver Completo' : 'Ver Paginado'}}
                </button>
              </div>

            </div>

          </mat-expansion-panel>

        </form>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <button mat-raised-button (click)="onSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
            <button mat-raised-button (click)="onExport()" [disabled]="isProcessing()" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
            <!-- <button mat-raised-button (click)="onExportDetalles()" [disabled]="isProcessing()" color="primary" class="zb-button">{{isExportingDetalles ? 'Exportando...' : 'Exportar con Detalles'}}</button> -->
          </div>
          <!-- <div fxFlex=25 fxFlex.xs=100 fxLayoutAlign="end center" class="flex-item">
          </div> -->
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
          <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
        </div>

        <mat-expansion-panel [expanded]="false" [hideToggle]="false" class="zb-readonly" *ngIf="!isValidating">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa fa-solid fa-chart-area fa-1x" style="margin-right: 5px;"></i> Estadísticas de la Búsqueda
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="totalIngresos != null">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
                <mat-label><b>TOTAL DE INGRESOS:</b></mat-label>
                <br/>
                <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                <ng-container *ngIf="!isStatisticsSearching">
                  <mat-label *ngFor="let item of totalIngresos | keyvalue" style="margin: 10px 0px 0px 10px;">
                    <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                  </mat-label>
                </ng-container>
              </mat-expansion-panel>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="totalEgresos != null">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
                <mat-label><b>TOTAL DE EGRESOS:</b></mat-label>
                <br/>
                <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                <ng-container *ngIf="!isStatisticsSearching">
                  <mat-label *ngFor="let item of totalEgresos | keyvalue" style="margin: 10px 0px 0px 10px;">
                    <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                  </mat-label>
                </ng-container>
              </mat-expansion-panel>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="totalNetos != null">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
                <mat-label><b>TOTAL DE BALANCES:</b></mat-label>
                <br/>
                <mat-label *ngIf="isStatisticsSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                <ng-container *ngIf="!isStatisticsSearching">
                  <mat-label *ngFor="let item of totalNetos | keyvalue" style="margin: 10px 0px 0px 10px;">
                    <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                  </mat-label>
                </ng-container>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <br/>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">

          <!-- *ngIf="!verSeparadoEnIva" -->
          <!-- Grilla mostrando solo Ingresos y Egresos -->
          <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="gridAllowPaging" [allowSorting]="true" [toolbar]='toolbarOptions'
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (actionBegin)="onActionBegin($event)">
            <e-columns>
              <e-column headerText='Concepto' field="Concepto" width=120></e-column>
              <e-column headerText='Cuenta' field="CuentaImputadaCodigo" width=90></e-column>
              <e-column headerText='Moneda' field="Moneda" width=70></e-column>
              <e-column headerText='Ingresos' field="Ingresos" width=85 textAlign="right" format="N2"></e-column>
              <e-column headerText='Egresos' field="Egresos" width=85 textAlign="right" format="N2"></e-column>
              <e-column headerText='Egresos Netos' field="EgresosNeto" width=85 textAlign="right" format="N2"></e-column>
              <e-column headerText='Egresos IVA' field="EgresosIva" width=85 textAlign="right" format="N2"></e-column>
              <e-column headerText='Balance' field="Neto" width=85 textAlign="right" format="N2">
                <ng-template #template let-data>
                  <mat-label [ngStyle]="{ color: (data.Neto >= 0) ? 'black' : 'indianred' }">{{data.Neto | number:'1.2-2'}}</mat-label>
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=60>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px;" (click)="openDialogDetalleMovimientos(data)" title="Ver detalle de movimientos">
                    <i class="fa fa-search fa-1x"></i>
                  </a>
                  <a style="cursor: pointer;" (click)="viewDetail(data)" title="Ver concepto" *ngIf="!filtroEstaAgrupadoPorTenant()">
                    <i class="fa fa-eye fa-1x"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>

          <!-- Grilla mostrando solo Ingresos y Egresos separado en neto e IVA -->
          <!-- <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="gridAllowPaging" [allowSorting]="true" [toolbar]='toolbarOptions'
            [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' *ngIf="verSeparadoEnIva" (actionBegin)="onActionBegin($event)">
            <e-columns>
              <e-column headerText='Concepto' field="Concepto" width=120></e-column>
              <e-column headerText='Moneda' field="Moneda" width=90></e-column>
              <e-column headerText='Cuenta' field="CuentaImputadaCodigo" width=90></e-column>
              <e-column headerText='Ingresos' field="Ingresos" width=90 textAlign="right" format="N2"></e-column>
              <e-column headerText='Egresos' field="Egresos" width=90 textAlign="right" format="N2"></e-column>
              <e-column headerText='Egresos Netos' field="EgresosNeto" width=90 textAlign="right" format="N2"></e-column>
              <e-column headerText='Egresos IVA' field="EgresosIva" width=90 textAlign="right" format="N2"></e-column>
              <e-column headerText='Balance' field="Neto" width=90 textAlign="right" format="N2">
                <ng-template #template let-data>
                  <mat-label [ngStyle]="{ color: (data.Neto >= 0) ? 'black' : 'indianred' }">{{data.Neto | number:'1.2-2'}}</mat-label>
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=40>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px;" (click)="openDialogDetalleMovimientos(data)" title="Ver detalle de movimientos">
                    <i class="fa fa-search fa-1x"></i>
                  </a>
                  <a style="cursor: pointer;" (click)="viewDetail(data)" title="Ver concepto" *ngIf="!filtroEstaAgrupadoPorTenant()">
                    <i class="fa fa-eye fa-1x"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid> -->

        </div>

      </ng-container>

    </mat-card-content>
  </mat-card>
